export default {
  async asyncData({ $axios, params }) {
    try{
      // 分页数据
      let pageinfo = {
        page: 1,
        per_page: 9,
        total: 0,
        type: 'map'
      }
      // 获取语言
      // const language = params.lang;
      let res = await $axios.get('/api/news/list', { params: { ...pageinfo } });
      let newsList = res.data.list;
      // 设置页码
      pageinfo.page = res.data.current_page;
      pageinfo.total = res.data.total || 0;
      return { newsList, pageinfo }
    }catch(e) {
      console.log(e);
    }
  },
  methods: {
    async getNewsList() {
      try{
        let res = await this.$axios.get('/api/news/list', { params: { ...this.pageinfo } });
        this.newsList = res.data.list
      }catch(e) {
        console.log(e);
      }
    },
    showSizeChange(page, pageSize) {
      // console.log('?', page, pageSize)
    },
    change(page, pageSize) {
      this.pageinfo.page = page;
      this.getNewsList();
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <a>Previous</a>;
      } else if (type === 'next') {
        return <a>Next</a>;
      }
      return originalElement;
    }
  }
}
